import "./web.df5bad77.js";
import "./web.1b47896f.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea073"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea073"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jLc13", function(module, exports) {

$parcel$export(module.exports, "HandleChangesNew", () => $beccbeb3484804e3$export$b77cf51cf3ea160);
function $beccbeb3484804e3$export$b77cf51cf3ea160(allData, changes, masterData, applyToAllRows, idFields) {
    let hasAnyChange = false;
    if (allData) {
        hasAnyChange = masterData.length > 0;
        masterData.length = 0;
    }
    if (changes.delete != null) for(let i = 0; i < changes.delete.length; ++i){
        let tmpObj = {};
        let idx = 0;
        for (const field of idFields)tmpObj[field] = changes.delete[i][idx++];
        const index = $beccbeb3484804e3$var$IndexOf(masterData, tmpObj, idFields);
        if (index > -1) {
            masterData.splice(index, 1);
            hasAnyChange = true;
        }
    }
    if (changes.upsert != null) for(let i = 0; i < changes.upsert.length; ++i){
        const change = changes.upsert[i];
        applyToAllRows(change);
        const index = $beccbeb3484804e3$var$IndexOf(masterData, change, idFields);
        if (index > -1) masterData[index] = change;
        else masterData.push(change);
        hasAnyChange = true;
    }
    return hasAnyChange;
}
function $beccbeb3484804e3$var$CreateId(value, idFields) {
    let out = '';
    for (const field of idFields)out = out + '-' + value[field];
    return out;
}
function $beccbeb3484804e3$var$IndexOf(input, value, idFields) {
    const valueId = $beccbeb3484804e3$var$CreateId(value, idFields);
    for(let i = 0; i < input.length; ++i){
        const id = $beccbeb3484804e3$var$CreateId(input[i], idFields);
        if (id == valueId) return i;
    }
    return -1;
}

});

parcelRegister("6dhn9", function(module, exports) {

$parcel$export(module.exports, "ParseDateOnly", () => $92f0f3dedfaa8a18$export$10df58c66de508e2);
$parcel$export(module.exports, "FormatDate", () => $92f0f3dedfaa8a18$export$68962dbd27cd2e36);
const $92f0f3dedfaa8a18$var$MONTHNAME = [
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember'
];
function $92f0f3dedfaa8a18$var$GetShortMonthName(month_idx) {
    let name = $92f0f3dedfaa8a18$var$MONTHNAME[month_idx];
    if (name.length > 4) name = name.substring(0, 3) + '.';
    return name;
}
function $92f0f3dedfaa8a18$export$10df58c66de508e2(input) {
    const timeSeparatorIndex = input.indexOf("T");
    if (timeSeparatorIndex > -1) return new Date(input.substring(0, timeSeparatorIndex));
    return new Date(input);
}
function $92f0f3dedfaa8a18$export$68962dbd27cd2e36(d, format) {
    let out = '';
    for(let i = 0; i < format.length; ++i){
        switch(format[i]){
            case 'H':
                if (format.length > i + 1 && format[i + 1] == 'H') {
                    out += d.getHours().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'M':
                if (format.length > i + 1 && format[i + 1] == 'M') {
                    out += d.getMinutes().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'S':
                if (format.length > i + 1 && format[i + 1] == 'S') {
                    out += d.getSeconds().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'd':
                if (format.length > i + 1 && format[i + 1] == 'd') {
                    out += d.getDate().toString().padStart(2, '0');
                    i++;
                    continue;
                }
                break;
            case 'm':
                let numConsecutive = 0;
                for(let j = i + 1; j < format.length; ++j){
                    if (format[j] == 'm') numConsecutive++;
                    else break;
                }
                switch(numConsecutive){
                    case 1:
                        out += (d.getMonth() + 1).toString().padStart(2, '0');
                        i += numConsecutive;
                        continue;
                    case 2:
                        out += $92f0f3dedfaa8a18$var$GetShortMonthName(d.getMonth());
                        i += numConsecutive;
                        continue;
                    case 3:
                        out += $92f0f3dedfaa8a18$var$MONTHNAME[d.getMonth()];
                        i += numConsecutive;
                        continue;
                }
                break;
            case 'y':
                if (format.length > i + 3 && format[i + 1] == 'y' && format[i + 2] == 'y' && format[i + 3] == 'y') {
                    out += d.getFullYear().toString().padStart(4, '0');
                    i += 3;
                    continue;
                }
            default:
                break;
        }
        out += format[i];
    }
    return out;
}

});


var $2NT5D = parcelRequire("2NT5D");
function $8d9911baf0237235$export$733fe92c85525b48(allClassesSelected, runner, time) {
    if (allClassesSelected) {
        let lastEventTime = null;
        for(const key in runner.times){
            time = runner.times[key];
            if (time === null || time.passing_time === null) continue;
            const timeAsUnixTime = Date.parse(time.passing_time);
            if (isNaN(timeAsUnixTime)) continue;
            if (lastEventTime == null || lastEventTime < timeAsUnixTime) lastEventTime = timeAsUnixTime;
        }
        if (lastEventTime === null) return Number.MIN_SAFE_INTEGER;
        return lastEventTime;
    }
    if (time === null || time.place === null) {
        // Note that time will be non-null even for intermediate points
        // where the runner has not passed yet, due to "running time".
        if (runner.status == (0, $2NT5D.RunnerStatus).REGISTERED) // The runner has not started yet.
        return Number.MAX_SAFE_INTEGER - 6;
        else if (runner.status == (0, $2NT5D.RunnerStatus).OK) return Number.MAX_SAFE_INTEGER - 7;
        // The runner is probably DNS/DNF/etc.
        return $8d9911baf0237235$export$284f9e95dbad9982(runner.status, null, runner.not_competing);
    }
    return $8d9911baf0237235$export$284f9e95dbad9982(runner.status, time.place, runner.not_competing);
}
function $8d9911baf0237235$export$284f9e95dbad9982(status, place, notCompeting) {
    if (notCompeting && status == (0, $2NT5D.RunnerStatus).REGISTERED) return Number.MAX_SAFE_INTEGER - 5;
    switch(status){
        case (0, $2NT5D.RunnerStatus).NC:
            return Number.MAX_SAFE_INTEGER - 5;
        case (0, $2NT5D.RunnerStatus).DSQ:
            return Number.MAX_SAFE_INTEGER - 4;
        case (0, $2NT5D.RunnerStatus).DNF:
            return Number.MAX_SAFE_INTEGER - 3;
        case (0, $2NT5D.RunnerStatus).DNS:
            return Number.MAX_SAFE_INTEGER - 2;
        default:
            return place;
    }
}



var $2NT5D = parcelRequire("2NT5D");

var $jLc13 = parcelRequire("jLc13");

var $2NT5D = parcelRequire("2NT5D");
function $d384bddd2738e522$export$6fc4d998c785a671(runner, code, raceAccuracy, onlyPlaceAndUsedTime) {
    let output = '';
    switch(runner.status){
        case (0, $2NT5D.RunnerStatus).DNS:
            output = 'DNS';
            break;
        case (0, $2NT5D.RunnerStatus).DNF:
            output = 'DNF';
            break;
        case (0, $2NT5D.RunnerStatus).DSQ:
            output = 'DSQ';
            break;
        case (0, $2NT5D.RunnerStatus).NC:
            output = 'NC';
            break;
        default:
            if ('not_competing' in runner && runner.not_competing) output = 'NC';
            break;
    }
    let time = null;
    if (code in runner.times) time = runner.times[code];
    if (time === null) return '';
    if (time.running_time !== null && !onlyPlaceAndUsedTime) {
        const formattedDuration = $d384bddd2738e522$export$888a45892fa851a8(time.running_time, false, 0, false);
        let out = '<div class="running-time">(';
        if (runner.not_competing) out = out + 'NC - ';
        else if (time.running_place !== null) out = out + time.running_place + ' - ';
        out = out + formattedDuration + ')</div>';
        if (time.running_difference != null) out = out + '<div class="combined-difference">' + $d384bddd2738e522$export$888a45892fa851a8(time.running_difference, false, 0, true) + '</div>';
        return out;
    }
    if (time.used_time === null && runner.status === (0, $2NT5D.RunnerStatus).OK && code === (0, $2NT5D.FINISH_CODE)) return 'OK';
    switch(runner.status){
        case (0, $2NT5D.RunnerStatus).NC:
            if (time.used_time !== null) output = output + ' - ';
        case (0, $2NT5D.RunnerStatus).OK:
        case (0, $2NT5D.RunnerStatus).REGISTERED:
            if (runner.not_competing && runner.status != (0, $2NT5D.RunnerStatus).NC && time.used_time !== null) output = output + ' - ';
            if (time.place !== null) output = output + time.place + ' - ';
            output = output + $d384bddd2738e522$export$888a45892fa851a8(time.used_time, code === (0, $2NT5D.FINISH_CODE), raceAccuracy, false);
            if (time.difference != null && !onlyPlaceAndUsedTime) output = output + '<div class="combined-difference">' + $d384bddd2738e522$export$888a45892fa851a8(time.difference, code === (0, $2NT5D.FINISH_CODE), raceAccuracy, true) + '</div>';
            break;
        case (0, $2NT5D.RunnerStatus).DSQ:
            if (time.used_time !== null) output = output + ' - ' + $d384bddd2738e522$export$888a45892fa851a8(time.used_time, code === (0, $2NT5D.FINISH_CODE), raceAccuracy, false);
            break;
    }
    return output;
}
const $d384bddd2738e522$var$MS_PER_SECOND = 1000;
const $d384bddd2738e522$var$MS_PER_MINUTE = $d384bddd2738e522$var$MS_PER_SECOND * 60;
const $d384bddd2738e522$var$MS_PER_HOUR = $d384bddd2738e522$var$MS_PER_MINUTE * 60;
function $d384bddd2738e522$export$888a45892fa851a8(milliseconds, showSubSecond, raceAccuracy, addPrefixSymbol) {
    if (milliseconds === null) return '';
    const negative = milliseconds < 0;
    milliseconds = Math.abs(milliseconds);
    const hours = Math.floor(milliseconds / $d384bddd2738e522$var$MS_PER_HOUR);
    milliseconds -= hours * $d384bddd2738e522$var$MS_PER_HOUR;
    const minutes = Math.floor(milliseconds / $d384bddd2738e522$var$MS_PER_MINUTE);
    milliseconds -= minutes * $d384bddd2738e522$var$MS_PER_MINUTE;
    const seconds = Math.floor(milliseconds / $d384bddd2738e522$var$MS_PER_SECOND);
    milliseconds -= seconds * $d384bddd2738e522$var$MS_PER_SECOND;
    let formatted = '';
    if (addPrefixSymbol) {
        if (negative) formatted += '-';
        else formatted += '+';
    }
    if (hours > 0) formatted += hours.toString().padStart(2, '0') + ':';
    formatted += minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    if (showSubSecond && raceAccuracy > 0) {
        const ms = milliseconds.toString().padStart(3, '0');
        return formatted + ',' + ms.substring(0, raceAccuracy);
    }
    return formatted;
}
function $d384bddd2738e522$export$fe2ea8b64ae89c83(unsafe) {
    if (unsafe === null) return null;
    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function $d384bddd2738e522$export$51b110cf028c41f2(runner, intermediatePointCode) {
    if (!(intermediatePointCode in runner.times)) return '';
    const time = runner.times[intermediatePointCode];
    if (time === null) return '';
    if (intermediatePointCode === (0, $2NT5D.FINISH_CODE)) {
        if (runner.status === (0, $2NT5D.RunnerStatus).REGISTERED) return '';
    } else {
        const propertiesToIgnore = {
            'running_time': true,
            'running_place': true,
            'running_difference': true
        };
        let allIsNull = true;
        for(const property in time)if (time[property] !== null && !(property in propertiesToIgnore)) {
            allIsNull = false;
            break;
        }
        if (allIsNull) return '';
        if (runner.status !== (0, $2NT5D.RunnerStatus).REGISTERED && runner.status !== (0, $2NT5D.RunnerStatus).OK) return '';
    }
    switch(runner.status){
        case (0, $2NT5D.RunnerStatus).DSQ:
            return 'DSQ';
        case (0, $2NT5D.RunnerStatus).DNF:
            return 'DNF';
        case (0, $2NT5D.RunnerStatus).DNS:
            return 'DNS';
        case (0, $2NT5D.RunnerStatus).NC:
            return 'NC';
        default:
            if (runner.not_competing) return 'NC';
            if (time.place === null) return 'OK';
            return time.place.toString();
    }
}
function $d384bddd2738e522$export$e1933d726482ba69(shootings, numShootings) {
    let output = '';
    for(let i = 0; i < numShootings; ++i){
        if (i > 0) output = output + '-';
        if (i >= shootings.length) output = output + 'x';
        else output = output + shootings[i];
    }
    return output;
}



var $gzR1g = parcelRequire("gzR1g");

var $2NT5D = parcelRequire("2NT5D");
// Taken from https://stackoverflow.com/questions/12369824/javascript-binary-search-insertion-preformance
function $ea459ee577d5e6bd$var$BinarySearch(sortedRunners, runningUsedTime) {
    let l = 0;
    let h = sortedRunners.length - 1;
    while(l <= h){
        const m = l + h >>> 1; /* equivalent to Math.floor((l + h) / 2) but faster */ 
        const comparison = sortedRunners[m].time - runningUsedTime;
        if (comparison < 0) l = m + 1;
        else if (comparison > 0) h = m - 1;
        else return m;
    }
    return ~l;
}
function $ea459ee577d5e6bd$export$fc00c3c9244e59b8(runner, now, classIntermediatePoint, relayTeamsStarttime, resultLookup, placeAndTime) {
    for(const key in runner.times){
        const time = runner.times[key];
        time.running_time = null;
        time.running_place = null;
        time.running_difference = null;
    }
    if (runner.status != (0, $2NT5D.RunnerStatus).REGISTERED) return;
    let stop = runner.starttime == null;
    let starttime = null;
    if (runner.relay_team != null && runner.relay_team != '') {
        const bibString = runner.bib.toString();
        let bibnumberLookup = bibString.substring(0, bibString.length - 2) + '01';
        starttime = relayTeamsStarttime[bibnumberLookup];
    } else if ('free_start' in placeAndTime && placeAndTime.free_start) {
        // Set stop to true, so that we only continue in the case
        // where we have an estimated starttime.
        stop = true;
        if ('estimated_starttime' in runner && runner.estimated_starttime != null) {
            starttime = runner.estimated_starttime;
            stop = runner.estimated_starttime == null;
        }
    } else starttime = runner.starttime;
    // Note that we intentionally check for runner.starttime!
    // If the runner hasn't started, we do not want to show any running clock.
    // NOTE: The above sentence only makes sense for relay.
    if (stop) return;
    let nextPassingCode = (0, $2NT5D.FINISH_CODE);
    let nextPassing = runner.times[nextPassingCode];
    for(let i = classIntermediatePoint.length - 1; i >= 0; --i){
        if (runner.relay_team != null && runner.leg_number != classIntermediatePoint[i].leg_number) continue;
        if (!(classIntermediatePoint[i].code in runner.times)) console.error('This should not happen');
        if (runner.times[classIntermediatePoint[i].code].passing_time != null) break;
        nextPassingCode = classIntermediatePoint[i].code;
        nextPassing = runner.times[nextPassingCode];
    }
    let unixtime = Date.parse(starttime);
    if (now >= unixtime) {
        // Round to closest second.
        let diff = Math.round((now - unixtime) / 1000) * 1000;
        if (placeAndTime.is_pursuit && 'time_previous_race' in runner && runner.time_previous_race != null) diff += runner.time_previous_race;
        if ('percentage' in runner && runner.percentage !== null) diff = diff * (runner.percentage / 100.0);
        let addMilliseconds = 0;
        if ('penalty' in placeAndTime) {
            const numShootingsToAdd = $ea459ee577d5e6bd$export$2a72f7f73063844c(nextPassingCode);
            let totalNumMisses = 0;
            if ('shootings' in runner && runner.shootings !== null) {
                for(let i = 0; i < runner.shootings.length; ++i){
                    if (numShootingsToAdd != -1 && i >= numShootingsToAdd) break;
                    const parsedShooting = Number.parseInt(runner.shootings[i]);
                    if (!Number.isNaN(parsedShooting)) totalNumMisses += parsedShooting;
                }
                addMilliseconds = placeAndTime.penalty * totalNumMisses;
            }
        }
        if (placeAndTime.show_time) nextPassing.running_time = diff + addMilliseconds;
        const not_competing = 'not_competing' in runner && runner.not_competing;
        if (!not_competing) {
            let sortedRunners = [];
            let legNumber = 1;
            if (runner.leg_number !== null) legNumber = runner.leg_number;
            if (runner.class_id in resultLookup.classes && legNumber in resultLookup.classes[runner.class_id].legs && nextPassingCode in resultLookup.classes[runner.class_id].legs[legNumber].intermediate_points) sortedRunners = resultLookup.classes[runner.class_id].legs[legNumber].intermediate_points[nextPassingCode];
            if (placeAndTime.show_place) {
                const index = $ea459ee577d5e6bd$var$BinarySearch(sortedRunners, diff);
                if (index < 0) nextPassing.running_place = ~index + 1;
                else nextPassing.running_place = sortedRunners[index].place;
            }
            if (sortedRunners.length > 0 && placeAndTime.show_time && placeAndTime.show_place) nextPassing.running_difference = diff - sortedRunners[0].time;
        }
    }
}
function $ea459ee577d5e6bd$export$8ea12da737c10ae1(classes, runners) {
    let resultLookup = {
        classes: {}
    };
    for (const classObj of classes)resultLookup.classes[classObj.class_id] = {
        show_place: classObj.show_place,
        show_time: classObj.show_time,
        legs: {}
    };
    for (const runner of runners){
        const not_competing = 'not_competing' in runner && runner.not_competing;
        const addToFinish = runner.status == (0, $2NT5D.RunnerStatus).OK && !not_competing;
        const addToIntermediate = (runner.status == (0, $2NT5D.RunnerStatus).REGISTERED || addToFinish) && !not_competing;
        if (!addToFinish && !addToIntermediate) continue;
        if (!(runner.class_id in resultLookup.classes)) continue;
        for(const code in runner.times){
            const time = runner.times[code];
            if (time.passing_time === null) continue;
            if (code == (0, $2NT5D.FINISH_CODE) && !addToFinish) continue;
            if (code != (0, $2NT5D.FINISH_CODE) && !addToIntermediate) continue;
            let leg_number = 1;
            if (runner.leg_number != null) leg_number = runner.leg_number;
            if (!(leg_number in resultLookup.classes[runner.class_id].legs)) resultLookup.classes[runner.class_id].legs[leg_number] = {
                intermediate_points: {}
            };
            if (!(code in resultLookup.classes[runner.class_id].legs[leg_number].intermediate_points)) resultLookup.classes[runner.class_id].legs[leg_number].intermediate_points[code] = [];
            resultLookup.classes[runner.class_id].legs[leg_number].intermediate_points[code].push({
                'place': time.place,
                'time': time.used_time
            });
        }
    }
    for(const class_id in resultLookup.classes){
        for(const leg_number in resultLookup.classes[class_id].legs)for(const code in resultLookup.classes[class_id].legs[leg_number].intermediate_points)resultLookup.classes[class_id].legs[leg_number].intermediate_points[code].sort(function(a, b) {
            return a.time - b.time;
        });
    }
    return resultLookup;
}
function $ea459ee577d5e6bd$export$2a72f7f73063844c(code) {
    // 66 is pre shooting
    // 70 is post shooting
    // 71 is pre-finish
    const codeStr = code.toString();
    if (codeStr.startsWith('66')) return Number.parseInt(codeStr.substring(2)) - 1;
    if (codeStr.startsWith('70')) return Number.parseInt(codeStr.substring(2));
    if (codeStr.startsWith('71')) return -1;
    if (codeStr == (0, $2NT5D.FINISH_CODE)) return -1;
    return 0;
}



var $jlXLs = parcelRequire("jlXLs");

var $gizSK = parcelRequire("gizSK");

var $fckDn = parcelRequire("fckDn");

var $hKsEd = parcelRequire("hKsEd");

var $6dhn9 = parcelRequire("6dhn9");
const $86cd7100c51a1fc1$var$ALL_LEGS = -1;
const $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES = 'classes';
const $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS = 'clubs';
const $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES = 'favourites';
let $86cd7100c51a1fc1$var$leftMenu = $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES;
const $86cd7100c51a1fc1$var$urlParams = new URLSearchParams(window.location.search);
const $86cd7100c51a1fc1$var$raceId = $86cd7100c51a1fc1$var$urlParams.get('id');
const $86cd7100c51a1fc1$var$autoScrollInterval = Number.parseInt($86cd7100c51a1fc1$var$urlParams.get('autoscroll'));
var $86cd7100c51a1fc1$var$webSocket = null;
var $86cd7100c51a1fc1$var$datatables = {
    mainTable: null,
    sprintTables: []
};
let $86cd7100c51a1fc1$var$sprintColumnDefsForClass = new Map();
let $86cd7100c51a1fc1$var$race = null;
let $86cd7100c51a1fc1$var$classes = [];
let $86cd7100c51a1fc1$var$intermediatePoints = [];
let $86cd7100c51a1fc1$var$intermediatePointsPerClass = new Map();
let $86cd7100c51a1fc1$var$messages = [];
let $86cd7100c51a1fc1$var$selectedGroupId = null;
let $86cd7100c51a1fc1$var$selectedIntermediatePoint = null;
let $86cd7100c51a1fc1$var$selectedLegNumber = null;
let $86cd7100c51a1fc1$var$selectedGroupIsSprint = false;
let $86cd7100c51a1fc1$var$columns = [];
let $86cd7100c51a1fc1$var$firstIntermediateColumnIndex = -1;
let $86cd7100c51a1fc1$var$lastIntermediateColumnIndex = -1;
let $86cd7100c51a1fc1$var$firstLoad = true;
let $86cd7100c51a1fc1$var$currentLanguage = (0, $gizSK.GetInitialLanguage)();
function $86cd7100c51a1fc1$var$StartLeftMenuAutoScroll(intervalInSeconds) {
    setInterval(function() {
        const leftMenu = document.getElementById('classes-children');
        // Do we scroll to the next page first?
        let currentPageIndex = $86cd7100c51a1fc1$var$datatables.mainTable.CurrentPageIndex();
        if ($86cd7100c51a1fc1$var$datatables.mainTable.NumPages() > currentPageIndex + 1) {
            $86cd7100c51a1fc1$var$datatables.mainTable.SetCurrentPageIndex(currentPageIndex + 1);
            $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
            return;
        }
        let selectNextGroup = false;
        for (const menuItemRaw of leftMenu.children){
            const menuItem = menuItemRaw;
            // We do not want to automatically select "Alle klasser".
            if (selectNextGroup && menuItem.dataset.allClasses == '0') {
                $86cd7100c51a1fc1$var$selectedGroupId = menuItem.dataset.classId;
                selectNextGroup = false;
                break;
            }
            if ($86cd7100c51a1fc1$var$ClassNameContainsClass(menuItem.className, 'selected')) selectNextGroup = true;
        }
        if (selectNextGroup) {
            const firstMenuItem = leftMenu.children[0];
            $86cd7100c51a1fc1$var$selectedGroupId = firstMenuItem.dataset.classId;
        }
        $86cd7100c51a1fc1$var$SelectedGroupChanged();
    }, intervalInSeconds * 1000);
}
window.onload = function() {
    const leftMenuClassesButton = document.getElementById('left-menu-classes');
    leftMenuClassesButton.onclick = $86cd7100c51a1fc1$var$SetLeftMenuClasses;
    const leftMenuClubsButton = document.getElementById('left-menu-clubs');
    leftMenuClubsButton.onclick = $86cd7100c51a1fc1$var$SetLeftMenuClubs;
    const leftMenuFavouritesButton = document.getElementById('left-menu-favourites');
    leftMenuFavouritesButton.onclick = $86cd7100c51a1fc1$var$SetLeftMenuFavourites;
    const exportExcelButton = document.getElementById('export-excel-button');
    exportExcelButton.onclick = $86cd7100c51a1fc1$var$ExportExcel;
    $86cd7100c51a1fc1$var$ReCreateDataTable();
    $86cd7100c51a1fc1$var$StartListeners();
    $86cd7100c51a1fc1$var$CalculateRunningTimeTimer();
    if (!Number.isNaN($86cd7100c51a1fc1$var$autoScrollInterval) && $86cd7100c51a1fc1$var$autoScrollInterval > 0) $86cd7100c51a1fc1$var$StartLeftMenuAutoScroll($86cd7100c51a1fc1$var$autoScrollInterval);
    document.getElementById('language-en-us').onclick = function() {
        $86cd7100c51a1fc1$var$currentLanguage = (0, $gizSK.UpdateLanguage)('en-US', false);
        $86cd7100c51a1fc1$var$ReCreateDataTable();
        $86cd7100c51a1fc1$var$PrintTableHeading();
        $86cd7100c51a1fc1$var$PrintIntermediatePoints();
    };
    document.getElementById('language-nb-no').onclick = function() {
        $86cd7100c51a1fc1$var$currentLanguage = (0, $gizSK.UpdateLanguage)('nb-NO', false);
        $86cd7100c51a1fc1$var$ReCreateDataTable();
        $86cd7100c51a1fc1$var$PrintTableHeading();
        $86cd7100c51a1fc1$var$PrintIntermediatePoints();
    };
    document.getElementById('decrease-font-size').onclick = function() {
        $86cd7100c51a1fc1$var$DecreaseFontSize();
    };
    document.getElementById('increase-font-size').onclick = function() {
        $86cd7100c51a1fc1$var$IncreaseFontSize();
    };
    $86cd7100c51a1fc1$var$currentLanguage = (0, $gizSK.UpdateLanguage)($86cd7100c51a1fc1$var$currentLanguage.code, true);
    const storedFontSize = localStorage.getItem('fontsize');
    if (storedFontSize !== null) $86cd7100c51a1fc1$var$SetFontSize(Number.parseFloat(storedFontSize));
    (0, $fckDn.StartPingTimer)('race.html?id=' + $86cd7100c51a1fc1$var$raceId, function() {
        return {
            'fontsize': localStorage.getItem('fontsize'),
            'language': $86cd7100c51a1fc1$var$currentLanguage.code
        };
    });
};
function $86cd7100c51a1fc1$var$GetFontSize(element) {
    if (element.style.fontSize == '') return 1.0;
    return Number.parseFloat(element.style.fontSize.substring(0, element.style.fontSize.length - 2));
}
function $86cd7100c51a1fc1$var$IncreaseFontSize() {
    const body = document.getElementsByTagName('body')[0];
    $86cd7100c51a1fc1$var$SetFontSize($86cd7100c51a1fc1$var$GetFontSize(body) * 1.1);
}
function $86cd7100c51a1fc1$var$DecreaseFontSize() {
    const body = document.getElementsByTagName('body')[0];
    $86cd7100c51a1fc1$var$SetFontSize($86cd7100c51a1fc1$var$GetFontSize(body) / 1.1);
}
function $86cd7100c51a1fc1$var$SetFontSize(size) {
    const body = document.getElementsByTagName('body')[0];
    body.style.fontSize = size.toFixed(2) + 'em';
    localStorage.setItem('fontsize', size.toString());
}
function $86cd7100c51a1fc1$var$RaceHasTag(tagName) {
    if ($86cd7100c51a1fc1$var$race.tags == null) return false;
    for (const tag of $86cd7100c51a1fc1$var$race.tags){
        if (tag === tagName) return true;
    }
    return false;
}
function $86cd7100c51a1fc1$var$IsRidderuka() {
    return $86cd7100c51a1fc1$var$RaceHasTag("ridderuka");
}
function $86cd7100c51a1fc1$var$ShowShootings() {
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES && $86cd7100c51a1fc1$var$selectedGroupId !== null) return $86cd7100c51a1fc1$var$NumShootingsInClass($86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId)) > 0;
    return $86cd7100c51a1fc1$var$MaxNumShootings() > 0;
}
function $86cd7100c51a1fc1$var$ShowNormalPlaceAndTime() {
    if ($86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.START_CODE) || $86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.COMBINED_CODE)) return false;
    return true;
}
function $86cd7100c51a1fc1$var$ShowStarttime() {
    if ($86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.START_CODE) || $86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.COMBINED_CODE)) return true;
    return false;
}
function $86cd7100c51a1fc1$var$ShowTimingChips() {
    return $86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.START_CODE);
}
function $86cd7100c51a1fc1$var$ShowCombinedPlaceAndTime() {
    return $86cd7100c51a1fc1$var$selectedIntermediatePoint == (0, $2NT5D.COMBINED_CODE);
}
function $86cd7100c51a1fc1$var$GetTableSort() {
    let showPlace = true;
    if ($86cd7100c51a1fc1$var$selectedGroupId !== null && $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        let selectedClass = $86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId);
        if (selectedClass !== null && 'show_place' in selectedClass) showPlace = selectedClass.show_place;
    }
    let order = [];
    if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.START_CODE)) order.push({
        column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('starttime'),
        sort_direction: (0, $hKsEd.SortDirection).Ascending
    });
    else if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.COMBINED_CODE)) {
        if (showPlace && $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
            let sortOrder = (0, $hKsEd.SortDirection).Ascending;
            if ($86cd7100c51a1fc1$var$selectedGroupId === null) sortOrder = (0, $hKsEd.SortDirection).Descending;
            order.push({
                column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('finish'),
                sort_direction: sortOrder
            });
            for(let i = $86cd7100c51a1fc1$var$lastIntermediateColumnIndex; i >= $86cd7100c51a1fc1$var$firstIntermediateColumnIndex; --i)order.push({
                column_idx: i,
                sort_direction: sortOrder
            });
        }
        order.push({
            column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('starttime'),
            sort_direction: (0, $hKsEd.SortDirection).Ascending
        });
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        if ($86cd7100c51a1fc1$var$selectedGroupId === null) order.push({
            column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('passing_time'),
            sort_direction: (0, $hKsEd.SortDirection).Descending
        });
        else if (showPlace) order.push({
            column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('place'),
            sort_direction: (0, $hKsEd.SortDirection).Ascending
        });
    }
    // Do a final sort on bib, name and runner_id to ensure stable sorting.
    order.push({
        column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('bib'),
        sort_direction: (0, $hKsEd.SortDirection).Ascending
    });
    order.push({
        column_idx: $86cd7100c51a1fc1$var$GetColumnIndex('name'),
        sort_direction: (0, $hKsEd.SortDirection).Ascending
    });
    // order.push({ column_idx: GetColumnIndex('runner_id'), sort_direction: SortDirection.Ascending });
    return order;
}
function $86cd7100c51a1fc1$var$FindMostUsedSortOrderForCode(code) {
    let orderCounts = {};
    for (const point of $86cd7100c51a1fc1$var$intermediatePoints)if (point.code === code) {
        if (point.sort_order in orderCounts) orderCounts[point.sort_order]++;
        else orderCounts[point.sort_order] = 1;
    }
    let arr = [];
    for(const key in orderCounts)arr.push({
        'sort_order': key,
        'count': orderCounts[key]
    });
    arr.sort((a, b)=>{
        return b.count - a.count;
    });
    return Number.parseInt(arr[0].sort_order);
}
function $86cd7100c51a1fc1$var$NameRender(data, row, type) {
    let out = '';
    if (row.family_name === null && row.given_name === null) ;
    else if (row.family_name === null || row.family_name.trim().length === 0) out = out + row.given_name;
    else if (row.given_name === null || row.given_name.trim().length === 0) out = out + row.family_name;
    else out = out + row.family_name + ', ' + row.given_name;
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return out;
    if (row.favourite) return '&starf;' + (0, $d384bddd2738e522$export$fe2ea8b64ae89c83)(out);
    if (out.length == 0) return "&nbsp;";
    return (0, $d384bddd2738e522$export$fe2ea8b64ae89c83)(out);
}
function $86cd7100c51a1fc1$var$CreateColumns() {
    const isRelay = $86cd7100c51a1fc1$var$selectedLegNumber !== null || $86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected() && $86cd7100c51a1fc1$var$AnyClassIsRelay();
    let isPursuit = $86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected() && $86cd7100c51a1fc1$var$AnyClassIsPursuit();
    if ($86cd7100c51a1fc1$var$selectedGroupId !== null && $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        let selectedClass = $86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId);
        isPursuit = $86cd7100c51a1fc1$var$ClassIsPursuit(selectedClass);
    }
    $86cd7100c51a1fc1$var$columns = [];
    if ($86cd7100c51a1fc1$var$ShowNormalPlaceAndTime()) $86cd7100c51a1fc1$var$columns.push({
        'data': null,
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_place,
        'cssStyle': [
            'align-right'
        ],
        'render': $86cd7100c51a1fc1$var$PlaceRender,
        'name': 'place',
        'sortType': (0, $hKsEd.ColumnTypeEnum).Number
    });
    $86cd7100c51a1fc1$var$columns.push({
        'data': null,
        'name': 'bib',
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_bib,
        'cssStyle': [
            'align-right'
        ],
        'sortType': (0, $hKsEd.ColumnTypeEnum).Number,
        'render': $86cd7100c51a1fc1$var$BibNumberRender
    });
    if ($86cd7100c51a1fc1$var$ShowAllLegs()) $86cd7100c51a1fc1$var$columns.push({
        'data': 'leg_number',
        'name': 'leg_number',
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_leg,
        'cssStyle': [
            'align-right'
        ]
    });
    if (isRelay) $86cd7100c51a1fc1$var$columns.push({
        'data': 'relay_team',
        'name': 'relay_team',
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_team,
        'render': (0, $d384bddd2738e522$export$fe2ea8b64ae89c83),
        'cssStyle': [
            'clickable-div'
        ]
    });
    $86cd7100c51a1fc1$var$columns.push({
        'data': null,
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_name,
        'name': 'name',
        'cssStyle': [
            'clickable-div'
        ],
        'render': $86cd7100c51a1fc1$var$NameRender
    });
    if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) $86cd7100c51a1fc1$var$columns.push({
        'data': 'class_name',
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_class_name,
        'name': 'class_name',
        'cssStyle': [
            'clickable-table-cell'
        ],
        'render': (0, $d384bddd2738e522$export$fe2ea8b64ae89c83)
    });
    if ($86cd7100c51a1fc1$var$leftMenu !== $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) $86cd7100c51a1fc1$var$columns.push({
        'data': 'club_name',
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_club_name,
        'name': 'club_name',
        'render': (0, $d384bddd2738e522$export$fe2ea8b64ae89c83),
        'cssStyle': [
            'clickable-table-cell'
        ]
    });
    if (!$86cd7100c51a1fc1$var$ShowCombinedPlaceAndTime() && $86cd7100c51a1fc1$var$ShowStarttime()) $86cd7100c51a1fc1$var$columns.push({
        'data': null,
        'render': $86cd7100c51a1fc1$var$StarttimeRender,
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_starttime,
        'cssStyle': [
            'align-right'
        ],
        'name': 'starttime',
        'sortType': (0, $hKsEd.ColumnTypeEnum).Number
    });
    if ($86cd7100c51a1fc1$var$ShowTimingChips()) $86cd7100c51a1fc1$var$columns.push({
        'data': 'timing_chips',
        'render': $86cd7100c51a1fc1$var$TimingChipsRender,
        'title': $86cd7100c51a1fc1$var$currentLanguage.race_chip_number,
        'cssStyle': [
            'align-right'
        ],
        'sortType': (0, $hKsEd.ColumnTypeEnum).Number
    });
    if ($86cd7100c51a1fc1$var$ShowNormalPlaceAndTime()) {
        $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_used_time,
            'cssStyle': [
                'align-right'
            ],
            'render': $86cd7100c51a1fc1$var$UsedTimeRender,
            'name': 'used_time',
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        });
        $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_difference,
            'cssStyle': [
                'align-right'
            ],
            'render': $86cd7100c51a1fc1$var$DifferenceRender,
            'name': 'difference',
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        });
        if (isRelay || isPursuit) $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': $86cd7100c51a1fc1$var$IsRidderuka() ? $86cd7100c51a1fc1$var$currentLanguage.race_used_time_leg_ridderuka : $86cd7100c51a1fc1$var$currentLanguage.race_used_time_leg,
            'cssStyle': [
                'align-right'
            ],
            'render': $86cd7100c51a1fc1$var$UsedTimeLegRender,
            'name': 'used_time_leg',
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        });
        if ($86cd7100c51a1fc1$var$ShowShootings()) $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_shootings,
            'render': $86cd7100c51a1fc1$var$ShootingRender
        });
        $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': '',
            'cssStyle': [
                'align-right',
                'small-table-text'
            ],
            'render': $86cd7100c51a1fc1$var$PassingTimeRender,
            'name': 'passing_time',
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        });
    }
    if ($86cd7100c51a1fc1$var$ShowCombinedPlaceAndTime()) {
        $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'render': $86cd7100c51a1fc1$var$StarttimeRender,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_starttime,
            'cssStyle': [
                'align-right'
            ],
            'name': 'starttime'
        });
        if ($86cd7100c51a1fc1$var$ShowShootings()) $86cd7100c51a1fc1$var$columns.push({
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_shootings,
            'render': $86cd7100c51a1fc1$var$ShootingRender
        });
        let points = $86cd7100c51a1fc1$var$GetIntermediatePointsForClassId($86cd7100c51a1fc1$var$selectedGroupId, $86cd7100c51a1fc1$var$selectedLegNumber);
        if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) points.sort((a, b)=>{
            return $86cd7100c51a1fc1$var$FindMostUsedSortOrderForCode(a.code) - $86cd7100c51a1fc1$var$FindMostUsedSortOrderForCode(b.code);
        });
        else points.sort((a, b)=>a.sort_order - b.sort_order);
        $86cd7100c51a1fc1$var$firstIntermediateColumnIndex = $86cd7100c51a1fc1$var$columns.length;
        for (const point of points){
            let columnHeader;
            if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) columnHeader = point.code.toString();
            else columnHeader = point.text;
            $86cd7100c51a1fc1$var$columns.push($86cd7100c51a1fc1$var$CreateCombinedTimeAndPlaceColumnDefinition(point.code, columnHeader));
        }
        $86cd7100c51a1fc1$var$lastIntermediateColumnIndex = $86cd7100c51a1fc1$var$columns.length - 1;
    }
    if ($86cd7100c51a1fc1$var$ShowCombinedPlaceAndTime()) $86cd7100c51a1fc1$var$columns.push($86cd7100c51a1fc1$var$CreateCombinedTimeAndPlaceColumnDefinition('finish', $86cd7100c51a1fc1$var$currentLanguage.race_finish));
    return null;
}
function $86cd7100c51a1fc1$var$BibNumberRender(data, row, type) {
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return row.bib;
    if (row.relay_team === null || row.relay_team.trim().length === 0) return row.bib;
    if (row.bib === null) return '';
    // Assume that the last two digits are leg number.
    const bibString = row.bib.toString();
    return bibString.substring(0, bibString.length - 2) + '-' + row.leg_number;
}
function $86cd7100c51a1fc1$var$InitializeSprintTables() {
    let columnsTemplate = [
        {
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_bib,
            'cssStyle': [
                'align-right'
            ],
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number,
            'render': $86cd7100c51a1fc1$var$BibNumberRender
        },
        {
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_name,
            'render': $86cd7100c51a1fc1$var$NameRender
        },
        {
            'data': null,
            'title': $86cd7100c51a1fc1$var$currentLanguage.race_used_time,
            'cssStyle': [
                'align-right'
            ],
            'render': $86cd7100c51a1fc1$var$CombinedPlaceAndTimeRender,
            'name': 'finish',
            'sortType': (0, $hKsEd.ColumnTypeEnum).Number
        }
    ];
    let runners = $86cd7100c51a1fc1$var$datatables.mainTable.data();
    let tableElements = document.getElementById('sprint').getElementsByClassName('sprint-table');
    for (let table of tableElements){
        const classId = table.dataset.classId;
        let newColumns = [];
        for (const col of columnsTemplate)newColumns.push(col);
        let points = $86cd7100c51a1fc1$var$GetIntermediatePointsForClassId(classId, null);
        points.sort((a, b)=>a.sort_order - b.sort_order);
        for (const point of points){
            const definition = $86cd7100c51a1fc1$var$CreateCombinedTimeAndPlaceColumnDefinition(point.code, point.text);
            newColumns.splice(newColumns.length - 1, 0, definition);
        }
        $86cd7100c51a1fc1$var$sprintColumnDefsForClass.set(classId, newColumns);
        let filter = function(runner) {
            return runner.class_id == classId;
        };
        let orderCols = [];
        for(let i = newColumns.length - 1; i > 1; --i)orderCols.push({
            column_idx: i,
            sort_direction: (0, $hKsEd.SortDirection).Ascending
        });
        orderCols.push({
            column_idx: 0,
            sort_direction: (0, $hKsEd.SortDirection).Ascending
        });
        let datatable = new (0, $hKsEd.ErikTable)(table, {
            'columns': newColumns,
            'data': runners,
            'id': 'runner_id',
            'sort': orderCols,
            'filter': filter
        });
        $86cd7100c51a1fc1$var$datatables.sprintTables.push(datatable);
    }
    for (let table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.newDraw();
}
function $86cd7100c51a1fc1$var$PrintSprint() {
    $86cd7100c51a1fc1$var$datatables.sprintTables = [];
    $86cd7100c51a1fc1$var$sprintColumnDefsForClass = new Map();
    document.getElementById('sprint').innerHTML = '';
    const selectedClass = $86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId);
    const sprintRoundTemplate = document.getElementById('sprint-round-template');
    for(let i = 0; i < selectedClass.sprint_total_number_of_rounds; ++i){
        let sprintRoundElement = sprintRoundTemplate.cloneNode(true);
        sprintRoundElement.hidden = false;
        $86cd7100c51a1fc1$var$CreateHtmlHeatsForRound(selectedClass, i, sprintRoundElement);
        document.getElementById('sprint').appendChild(sprintRoundElement);
    }
    $86cd7100c51a1fc1$var$InitializeSprintTables();
}
function $86cd7100c51a1fc1$var$CreateHtmlHeatsForRound(parentClass, roundIndex, divToAppendTo) {
    const classIdPrefix = parentClass.class_id + "-" + roundIndex + "-";
    const sprintHeatTemplate = document.getElementById('sprint-heat-template');
    for (const classObj of $86cd7100c51a1fc1$var$classes)if (classObj.class_id.startsWith(classIdPrefix)) {
        // Remove the parent class name, and uppercase the first character.
        let headerText = classObj.name.substring(parentClass.name.length).trim();
        headerText = headerText.charAt(0).toUpperCase() + headerText.substring(1);
        if ('first_start' in classObj && classObj.first_start !== null) headerText += ' - (' + (0, $6dhn9.FormatDate)(new Date(classObj.first_start), 'HH:MM:SS') + ')';
        let sprintHeatElement = sprintHeatTemplate.cloneNode(true);
        sprintHeatElement.hidden = false;
        sprintHeatElement.getElementsByClassName('sprint-round-header')[0].innerText = headerText;
        sprintHeatElement.getElementsByClassName('sprint-table')[0].dataset.classId = classObj.class_id;
        divToAppendTo.appendChild(sprintHeatElement);
    }
}
function $86cd7100c51a1fc1$var$CellClicked(column, clickedRow) {
    if (column.name == 'club_name') {
        $86cd7100c51a1fc1$var$selectedGroupId = clickedRow.club_name;
        $86cd7100c51a1fc1$var$SetLeftMenuClubs();
    } else if (column.name == 'class_name') {
        const classObj = $86cd7100c51a1fc1$var$GetClass(clickedRow.class_id);
        if ($86cd7100c51a1fc1$var$IsSprintClass(classObj)) {
            if (classObj.class_id.endsWith('-prolog')) $86cd7100c51a1fc1$var$selectedGroupId = classObj.class_id;
            else $86cd7100c51a1fc1$var$selectedGroupId = classObj.parent_class_id;
        } else $86cd7100c51a1fc1$var$selectedGroupId = clickedRow.class_id;
        $86cd7100c51a1fc1$var$SetLeftMenuClasses();
    } else if (column.name == 'name') {
        clickedRow.favourite = !clickedRow.favourite;
        $86cd7100c51a1fc1$var$SaveSettings();
        $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
        return;
    } else if (column.name == 'relay_team') {
        const newValue = !clickedRow.favourite;
        for (const row of $86cd7100c51a1fc1$var$datatables.mainTable.data())if (row.relay_team == clickedRow.relay_team && row.class_id == clickedRow.class_id) row.favourite = newValue;
        $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
        $86cd7100c51a1fc1$var$SaveSettings();
    }
    $86cd7100c51a1fc1$var$SelectedGroupChanged();
}
function $86cd7100c51a1fc1$var$ReCreateDataTable() {
    if ($86cd7100c51a1fc1$var$selectedGroupIsSprint) {
        document.getElementById('tblContainer').classList.add('hidden');
        document.getElementById('intermediate-points').classList.add('hidden');
        document.getElementById('export-buttons').classList.add('hidden');
        document.getElementById('sprint').classList.remove('hidden');
        $86cd7100c51a1fc1$var$PrintSprint();
        return;
    }
    document.getElementById('sprint').classList.add('hidden');
    document.getElementById('intermediate-points').classList.remove('hidden');
    document.getElementById('export-buttons').classList.remove('hidden');
    let data = [];
    let previousPageLength = 50;
    const first = $86cd7100c51a1fc1$var$datatables.mainTable === null;
    if ($86cd7100c51a1fc1$var$datatables.mainTable !== null) {
        document.getElementById('tblContainer').classList.remove('hidden');
        data = $86cd7100c51a1fc1$var$datatables.mainTable.data();
        previousPageLength = $86cd7100c51a1fc1$var$datatables.mainTable.pageLength();
    }
    document.getElementById('runnerTable').innerHTML = '';
    $86cd7100c51a1fc1$var$CreateColumns();
    let config = {
        'columns': $86cd7100c51a1fc1$var$columns,
        'id': 'runner_id',
        'cellClicked': $86cd7100c51a1fc1$var$CellClicked,
        'paging': [
            25,
            50,
            100,
            -1
        ],
        'rowsPerPage': previousPageLength,
        'sort': $86cd7100c51a1fc1$var$GetTableSort(),
        'data': data,
        'conditionalRowStyling': function(row) {
            if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.START_CODE) || $86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.COMBINED_CODE)) return [];
            if ($86cd7100c51a1fc1$var$IsTimeRecentEvent(row.times[$86cd7100c51a1fc1$var$selectedIntermediatePoint], $86cd7100c51a1fc1$var$recentRowLimit)) return [
                'recent-event'
            ];
            return [];
        }
    };
    if ($86cd7100c51a1fc1$var$leftMenu == $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) config.i18n = {
        emptyTable: $86cd7100c51a1fc1$var$currentLanguage.race_add_favourites
    };
    else config.i18n = {
        emptyTable: $86cd7100c51a1fc1$var$currentLanguage.race_no_runners
    };
    $86cd7100c51a1fc1$var$datatables.mainTable = new (0, $hKsEd.ErikTable)('runnerTable', config);
    $86cd7100c51a1fc1$var$SetTableSearch();
    $86cd7100c51a1fc1$var$recentRowLimit = $86cd7100c51a1fc1$var$GetMarkRecentRowLimit();
    $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
    $86cd7100c51a1fc1$var$PrintRunnerStatistics();
}
function $86cd7100c51a1fc1$var$LoadSettings() {
    const str = localStorage.getItem($86cd7100c51a1fc1$var$raceId);
    if (str == null) return {
        'favourites': {}
    };
    try {
        return JSON.parse(str);
    } catch (ex) {
        return {
            'favourites': {}
        };
    }
}
function $86cd7100c51a1fc1$var$SaveSettings() {
    let settings = $86cd7100c51a1fc1$var$LoadSettings();
    settings.favourites = {};
    for (const runner of $86cd7100c51a1fc1$var$datatables.mainTable.data())if (runner.favourite) settings.favourites[runner.runner_id] = true;
    localStorage.setItem($86cd7100c51a1fc1$var$raceId, JSON.stringify(settings));
}
function $86cd7100c51a1fc1$var$SelectedIntermediatePointChanged() {
    let intermediateElements = document.getElementById('intermediate-points').children;
    for(let i = 0; i < intermediateElements.length; ++i){
        let element = intermediateElements[i];
        if (element.dataset.code == $86cd7100c51a1fc1$var$selectedIntermediatePoint) $86cd7100c51a1fc1$var$AddClass(element, 'selected');
        else $86cd7100c51a1fc1$var$RemoveClass(element, 'selected');
    }
    $86cd7100c51a1fc1$var$ReCreateDataTable();
    $86cd7100c51a1fc1$var$PrintTableHeading();
}
function $86cd7100c51a1fc1$var$IntermediatePointClicked() {
    $86cd7100c51a1fc1$var$selectedIntermediatePoint = this.dataset.code;
    $86cd7100c51a1fc1$var$SelectedIntermediatePointChanged();
}
function $86cd7100c51a1fc1$var$CreateIntermediateDiv(text, code) {
    let div = document.createElement('div');
    div.innerText = text;
    div.dataset.code = code;
    div.onclick = $86cd7100c51a1fc1$var$IntermediatePointClicked;
    $86cd7100c51a1fc1$var$AddClass(div, 'clickable-div');
    $86cd7100c51a1fc1$var$AddClass(div, 'intermediate-point');
    $86cd7100c51a1fc1$var$AddClass(div, 'blue-header');
    if (code == $86cd7100c51a1fc1$var$selectedIntermediatePoint) $86cd7100c51a1fc1$var$AddClass(div, 'selected');
    return div;
}
function $86cd7100c51a1fc1$var$PrintIntermediatePoints() {
    let intermediatePointsContainer = document.getElementById('intermediate-points');
    intermediatePointsContainer.innerHTML = '';
    intermediatePointsContainer.appendChild($86cd7100c51a1fc1$var$CreateIntermediateDiv($86cd7100c51a1fc1$var$currentLanguage.race_startlist, (0, $2NT5D.START_CODE)));
    const points = $86cd7100c51a1fc1$var$GetIntermediatePointsForClassId($86cd7100c51a1fc1$var$selectedGroupId, $86cd7100c51a1fc1$var$selectedLegNumber);
    for (const point of points){
        var textToPrint = point.text;
        if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) textToPrint = point.code;
        intermediatePointsContainer.appendChild($86cd7100c51a1fc1$var$CreateIntermediateDiv(textToPrint, point.code));
    }
    intermediatePointsContainer.appendChild($86cd7100c51a1fc1$var$CreateIntermediateDiv($86cd7100c51a1fc1$var$currentLanguage.race_finish, (0, $2NT5D.FINISH_CODE)));
    intermediatePointsContainer.appendChild($86cd7100c51a1fc1$var$CreateIntermediateDiv($86cd7100c51a1fc1$var$currentLanguage.race_combined_list, (0, $2NT5D.COMBINED_CODE)));
    /*
     * Ensure that we have an intermediate point selected.
     */ let intermediateExists = false;
    let intermediateElements = document.getElementById('intermediate-points').children;
    for(let i = 0; i < intermediateElements.length; ++i){
        let element = intermediateElements[i];
        if (element.dataset.code == $86cd7100c51a1fc1$var$selectedIntermediatePoint) {
            intermediateExists = true;
            break;
        }
    }
    if (!intermediateExists && intermediateElements.length > 0) {
        $86cd7100c51a1fc1$var$selectedIntermediatePoint = intermediateElements[0].dataset.code;
        $86cd7100c51a1fc1$var$SelectedIntermediatePointChanged();
    }
}
function $86cd7100c51a1fc1$var$CreateCombinedTimeAndPlaceColumnDefinition(pointName, title) {
    return {
        'title': title,
        'data': null,
        'render': $86cd7100c51a1fc1$var$CombinedPlaceAndTimeRender,
        'name': pointName,
        'cssStyle': [
            'align-right',
            'combined-time-column'
        ],
        'sortType': (0, $hKsEd.ColumnTypeEnum).Number,
        'conditionalCellStyling': function(row) {
            if ($86cd7100c51a1fc1$var$selectedGroupIsSprint) return [];
            if (!(pointName in row.times)) // Runner does not have this intermediate time.
            return [
                'stripes'
            ];
            if ($86cd7100c51a1fc1$var$IsTimeRecentEvent(row.times[pointName], $86cd7100c51a1fc1$var$recentRowLimit)) return [
                'recent-event'
            ];
            return [];
        }
    };
}
function $86cd7100c51a1fc1$var$PlaceRender(data, row, type) {
    let intermediatePointToUse = $86cd7100c51a1fc1$var$selectedIntermediatePoint;
    if ($86cd7100c51a1fc1$var$selectedGroupIsSprint) intermediatePointToUse = (0, $2NT5D.FINISH_CODE);
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) {
        if (!(intermediatePointToUse in row.times)) return Number.MAX_VALUE;
        const time = row.times[intermediatePointToUse];
        if (time === null) return Number.MAX_VALUE;
        return (0, $8d9911baf0237235$export$284f9e95dbad9982)(row.status, row.times[intermediatePointToUse].place, row.not_competing);
    }
    return (0, $d384bddd2738e522$export$51b110cf028c41f2)(row, intermediatePointToUse);
}
// TODO: Combine this with UsedTimeRender.
function $86cd7100c51a1fc1$var$UsedTimeLegRender(_, row, type) {
    if (!($86cd7100c51a1fc1$var$selectedIntermediatePoint in row.times)) return null;
    const time = row.times[$86cd7100c51a1fc1$var$selectedIntermediatePoint];
    switch(row.status){
        case (0, $2NT5D.RunnerStatus).DNF:
        case (0, $2NT5D.RunnerStatus).DNS:
            return null;
        default:
            if (type == (0, $hKsEd.RenderTypeEnum).Sort) return time.used_time_leg;
            return (0, $d384bddd2738e522$export$888a45892fa851a8)(time.used_time_leg, $86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.FINISH_CODE), $86cd7100c51a1fc1$var$race.accuracy, false);
    }
}
function $86cd7100c51a1fc1$var$ShootingRender(_, row, _type) {
    if (!$86cd7100c51a1fc1$var$classLookup.has(row.class_id)) return '';
    const classObj = $86cd7100c51a1fc1$var$classLookup.get(row.class_id);
    const numShootings = $86cd7100c51a1fc1$var$NumShootingsInClass(classObj);
    return (0, $d384bddd2738e522$export$e1933d726482ba69)(row.shootings, numShootings);
}
function $86cd7100c51a1fc1$var$UsedTimeRender(_, row, type) {
    let intermediatePointToUse = $86cd7100c51a1fc1$var$selectedIntermediatePoint;
    if ($86cd7100c51a1fc1$var$selectedGroupIsSprint) intermediatePointToUse = (0, $2NT5D.FINISH_CODE);
    if (!(intermediatePointToUse in row.times)) return null;
    const time = row.times[intermediatePointToUse];
    switch(row.status){
        case (0, $2NT5D.RunnerStatus).DNF:
        case (0, $2NT5D.RunnerStatus).DNS:
            return null;
        default:
            if (type == (0, $hKsEd.RenderTypeEnum).Sort) return time.used_time;
            return (0, $d384bddd2738e522$export$888a45892fa851a8)(time.used_time, intermediatePointToUse === (0, $2NT5D.FINISH_CODE), $86cd7100c51a1fc1$var$race.accuracy, false);
    }
}
function $86cd7100c51a1fc1$var$DifferenceRender(_, row, type) {
    if (!($86cd7100c51a1fc1$var$selectedIntermediatePoint in row.times)) return null;
    const time = row.times[$86cd7100c51a1fc1$var$selectedIntermediatePoint];
    switch(row.status){
        case (0, $2NT5D.RunnerStatus).DNF:
        case (0, $2NT5D.RunnerStatus).DNS:
        case (0, $2NT5D.RunnerStatus).DSQ:
            return null;
        default:
            if (type == (0, $hKsEd.RenderTypeEnum).Sort) return time.difference;
            return (0, $d384bddd2738e522$export$888a45892fa851a8)(time.difference, $86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.FINISH_CODE), $86cd7100c51a1fc1$var$race.accuracy, true);
    }
}
function $86cd7100c51a1fc1$var$PassingTimeRender(_, row, type) {
    if (!($86cd7100c51a1fc1$var$selectedIntermediatePoint in row.times)) return null;
    const time = row.times[$86cd7100c51a1fc1$var$selectedIntermediatePoint];
    const passingTime = time.passing_time;
    if (passingTime === null) return null;
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return Date.parse(passingTime);
    return (0, $6dhn9.FormatDate)(new Date(passingTime), 'HH:MM:SS');
}
function $86cd7100c51a1fc1$var$ClassIdIsFreeStart(class_id) {
    if (!$86cd7100c51a1fc1$var$classLookup.has(class_id)) return false;
    const classObj = $86cd7100c51a1fc1$var$classLookup.get(class_id);
    if (!('free_start' in classObj)) return false;
    return classObj.free_start;
}
function $86cd7100c51a1fc1$var$StarttimeRender(_, data, type) {
    const free_start = $86cd7100c51a1fc1$var$ClassIdIsFreeStart(data.class_id);
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) {
        if (free_start) return Number.MAX_SAFE_INTEGER;
        if (data.starttime === null || data.starttime.trim() == '') return Number.MAX_SAFE_INTEGER;
        return Date.parse(data.starttime);
    }
    if (free_start) return $86cd7100c51a1fc1$var$currentLanguage.free_start;
    if (data.starttime === null || data.starttime.trim() == '') return '';
    return (0, $6dhn9.FormatDate)(new Date(data.starttime), 'HH:MM:SS');
}
function $86cd7100c51a1fc1$var$TimingChipsRender(data, row, type) {
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) {
        if (data === null || data.length == 0) return Number.MIN_SAFE_INTEGER;
        return data[0];
    }
    if (data == null) return '';
    let out = '';
    for (const timingChip of data){
        if (out.length > 0) out += ', ';
        out += timingChip.toString();
    }
    return out;
}
function $86cd7100c51a1fc1$var$CombinedPlaceAndTimeRender(_, row, type, column) {
    let time = null;
    let code = column.name;
    if (code in row.times) time = row.times[code];
    if (type == (0, $hKsEd.RenderTypeEnum).Sort) return (0, $8d9911baf0237235$export$733fe92c85525b48)($86cd7100c51a1fc1$var$selectedGroupId == null, row, time);
    return (0, $d384bddd2738e522$export$6fc4d998c785a671)(row, code, $86cd7100c51a1fc1$var$race.accuracy, $86cd7100c51a1fc1$var$selectedGroupIsSprint);
}
function $86cd7100c51a1fc1$var$GetClass(classId) {
    if ($86cd7100c51a1fc1$var$classLookup.has(classId)) return $86cd7100c51a1fc1$var$classLookup.get(classId);
    return null;
}
function $86cd7100c51a1fc1$var$ClassIdIsRelay(classId) {
    const classObj = $86cd7100c51a1fc1$var$GetClass(classId);
    if (classObj !== null) return $86cd7100c51a1fc1$var$ClassIsRelay(classObj);
    return false;
}
function $86cd7100c51a1fc1$var$ClassIsRelay(classObj) {
    return 'is_relay' in classObj && classObj.is_relay;
}
function $86cd7100c51a1fc1$var$ClassIsPursuit(classObj) {
    return 'is_pursuit' in classObj && classObj.is_pursuit;
}
function $86cd7100c51a1fc1$var$NumShootingsInClass(classObj) {
    if ('num_shootings' in classObj) return classObj.num_shootings;
    return 0;
}
function $86cd7100c51a1fc1$var$MaxNumShootings() {
    let max = 0;
    for (const classObj of $86cd7100c51a1fc1$var$classes)max = Math.max(max, $86cd7100c51a1fc1$var$NumShootingsInClass(classObj));
    return max;
}
function $86cd7100c51a1fc1$var$AnyClassIsRelay() {
    for (const classObj of $86cd7100c51a1fc1$var$classes){
        if ($86cd7100c51a1fc1$var$ClassIsRelay(classObj)) return true;
    }
    return false;
}
function $86cd7100c51a1fc1$var$AnyClassIsPursuit() {
    for (const classObj of $86cd7100c51a1fc1$var$classes){
        if ($86cd7100c51a1fc1$var$ClassIsPursuit(classObj)) return true;
    }
    return false;
}
function $86cd7100c51a1fc1$var$SetTableSearch() {
    let filters = [];
    if ($86cd7100c51a1fc1$var$selectedGroupId !== null) {
        if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) filters.push(function(runner) {
            return runner.class_id == $86cd7100c51a1fc1$var$selectedGroupId;
        });
        else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) filters.push(function(runner) {
            return runner.club_name == $86cd7100c51a1fc1$var$selectedGroupId;
        });
    }
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) filters.push(function(runner) {
        return runner.favourite;
    });
    if ($86cd7100c51a1fc1$var$selectedIntermediatePoint !== (0, $2NT5D.START_CODE) && $86cd7100c51a1fc1$var$selectedIntermediatePoint !== (0, $2NT5D.COMBINED_CODE)) {
        if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.FINISH_CODE)) filters.push(function(runner) {
            switch(runner.status){
                case (0, $2NT5D.RunnerStatus).DNF:
                case (0, $2NT5D.RunnerStatus).OK:
                case (0, $2NT5D.RunnerStatus).DSQ:
                case (0, $2NT5D.RunnerStatus).DNS:
                case (0, $2NT5D.RunnerStatus).NC:
                    return true;
                default:
                    return false;
            }
        });
        else filters.push(function(runner) {
            let intermediatePointToUse = $86cd7100c51a1fc1$var$selectedIntermediatePoint;
            if ($86cd7100c51a1fc1$var$selectedGroupIsSprint) intermediatePointToUse = (0, $2NT5D.FINISH_CODE);
            const formattedPlace = (0, $d384bddd2738e522$export$51b110cf028c41f2)(runner, intermediatePointToUse);
            return formattedPlace.length > 0;
        });
    }
    if ($86cd7100c51a1fc1$var$selectedLegNumber !== null && !$86cd7100c51a1fc1$var$ShowAllLegs()) filters.push(function(runner) {
        return runner.leg_number == $86cd7100c51a1fc1$var$selectedLegNumber;
    });
    $86cd7100c51a1fc1$var$datatables.mainTable.setFilter(function(runner) {
        for (const filter of filters){
            if (!filter(runner)) return false;
        }
        return true;
    });
}
function $86cd7100c51a1fc1$var$GetColumnIndex(columnName) {
    for(let i = 0; i < $86cd7100c51a1fc1$var$columns.length; ++i){
        if ('name' in $86cd7100c51a1fc1$var$columns[i] && $86cd7100c51a1fc1$var$columns[i].name == columnName) return i;
    }
    return -1;
}
function $86cd7100c51a1fc1$var$GatherDistinctIntermediatePoints(legNumber) {
    if (legNumber === null) legNumber = 1;
    var seenPoints = new Set();
    var returnValue = [];
    for (const point of $86cd7100c51a1fc1$var$intermediatePoints){
        if (point.leg_number != legNumber) continue;
        if (seenPoints.has(point.code)) continue;
        seenPoints.add(point.code);
        returnValue.push(point);
    }
    return returnValue;
}
function $86cd7100c51a1fc1$var$GetIntermediatePointsForClassId(classId, legNumber) {
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS || $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES || classId === null) return $86cd7100c51a1fc1$var$GatherDistinctIntermediatePoints(legNumber);
    if (legNumber === null) legNumber = 1;
    var returnValue = [];
    for (const point of $86cd7100c51a1fc1$var$intermediatePoints)if (point.class_id == classId && point.leg_number == legNumber) returnValue.push(point);
    return returnValue;
}
let $86cd7100c51a1fc1$var$resultLookup = {
    classes: {}
};
function $86cd7100c51a1fc1$var$RebuildIntermediatePointsPerClass() {
    $86cd7100c51a1fc1$var$intermediatePointsPerClass.clear();
    for (const classObj of $86cd7100c51a1fc1$var$classes)$86cd7100c51a1fc1$var$intermediatePointsPerClass.set(classObj.class_id, []);
    for (const intermediatePoint of $86cd7100c51a1fc1$var$intermediatePoints){
        if (!$86cd7100c51a1fc1$var$intermediatePointsPerClass.has(intermediatePoint.class_id)) $86cd7100c51a1fc1$var$intermediatePointsPerClass.set(intermediatePoint.class_id, []);
        $86cd7100c51a1fc1$var$intermediatePointsPerClass.get(intermediatePoint.class_id).push(intermediatePoint);
    }
}
function $86cd7100c51a1fc1$var$StartListeners() {
    $86cd7100c51a1fc1$var$webSocket = new (0, $gzR1g.NewWebsocket)($86cd7100c51a1fc1$var$raceId, [
        'runners',
        'classes',
        'races',
        'messages',
        'intermediate_points'
    ], true);
    $86cd7100c51a1fc1$var$webSocket.DataReceived = function(collectionName, data, fullReload, idFieldsFromManifest) {
        switch(collectionName){
            case 'runners':
                $86cd7100c51a1fc1$var$HandleRunnersChanged(data, fullReload);
                break;
            case 'classes':
                $86cd7100c51a1fc1$var$HandleClassesChanged(data, fullReload, idFieldsFromManifest);
                break;
            case 'messages':
                $86cd7100c51a1fc1$var$HandleMessagesChanged(data, fullReload, idFieldsFromManifest);
                break;
            case 'races':
                $86cd7100c51a1fc1$var$RaceChanged(data);
                break;
            case 'intermediate_points':
                $86cd7100c51a1fc1$var$HandleIntermediatePointsChanged(data, fullReload, idFieldsFromManifest);
                break;
        }
        $86cd7100c51a1fc1$var$firstLoad = false;
    };
}
function $86cd7100c51a1fc1$var$HandleIntermediatePointsChanged(changes, allData, idFieldsFromManifest) {
    const hasAnyChange = (0, $jLc13.HandleChangesNew)(allData, changes, $86cd7100c51a1fc1$var$intermediatePoints, (a)=>{
        if (!('leg_number' in a)) a.leg_number = 1;
    }, idFieldsFromManifest);
    if (hasAnyChange) {
        $86cd7100c51a1fc1$var$intermediatePoints.sort(function(a, b) {
            return a.sort_order - b.sort_order;
        });
        $86cd7100c51a1fc1$var$RebuildIntermediatePointsPerClass();
        (0, $jlXLs.EnsureAllIntermediatePointsArePresent)($86cd7100c51a1fc1$var$datatables.mainTable.data(), $86cd7100c51a1fc1$var$intermediatePoints);
        /*
         * Lets us re-create the datatable to ensure that any changes to
         * intermediate points becomes visible.
         */ $86cd7100c51a1fc1$var$ReCreateDataTable();
        $86cd7100c51a1fc1$var$SelectedGroupChanged();
    }
}
function $86cd7100c51a1fc1$var$HandleMessagesChanged(changes, allData, idFieldsFromManifest) {
    if (allData) $86cd7100c51a1fc1$var$messages = [];
    const hasAnyChanges = (0, $jLc13.HandleChangesNew)(allData, changes, $86cd7100c51a1fc1$var$messages, ()=>{}, idFieldsFromManifest);
    if (hasAnyChanges) {
        $86cd7100c51a1fc1$var$messages.sort(function(a, b) {
            return Date.parse(b.time_of_message) - Date.parse(a.time_of_message);
        });
        let messagesChildren = document.getElementById('messages-children');
        messagesChildren.innerHTML = '';
        for(let i = 0; i < 3 && i < $86cd7100c51a1fc1$var$messages.length; ++i){
            const message = $86cd7100c51a1fc1$var$messages[i];
            let td = document.createElement('td');
            td.innerText = (0, $6dhn9.FormatDate)(new Date(message.time_of_message), 'HH:MM:SS') + ' - ' + message.message;
            let tr = document.createElement('tr');
            tr.appendChild(td);
            messagesChildren.appendChild(tr);
        }
    }
}
function $86cd7100c51a1fc1$var$HandleClassesChanged(changes, allData, idFieldsFromManifest) {
    const hasAnyChange = (0, $jLc13.HandleChangesNew)(allData, changes, $86cd7100c51a1fc1$var$classes, ()=>{}, idFieldsFromManifest);
    if (hasAnyChange) {
        $86cd7100c51a1fc1$var$classes.sort((a, b)=>{
            if (a.sort_order == b.sort_order) return a.name.localeCompare(b.name);
            return a.sort_order - b.sort_order;
        });
        $86cd7100c51a1fc1$var$RebuildClassLookup();
        $86cd7100c51a1fc1$var$RebuildIntermediatePointsPerClass();
        $86cd7100c51a1fc1$var$RebuildResultLookup();
        if ($86cd7100c51a1fc1$var$firstLoad) for (const classObj of $86cd7100c51a1fc1$var$classes){
            if ($86cd7100c51a1fc1$var$IsSprintClass(classObj) && 'parent_class_id' in classObj && classObj.parent_class_id == null) {
                $86cd7100c51a1fc1$var$selectedGroupId = classObj.class_id + '-prolog';
                break;
            } else if (!$86cd7100c51a1fc1$var$IsSprintClass(classObj)) {
                $86cd7100c51a1fc1$var$selectedGroupId = classObj.class_id;
                break;
            }
        }
        $86cd7100c51a1fc1$var$PrintLeftMenu();
        $86cd7100c51a1fc1$var$SelectedGroupChanged();
    }
}
function $86cd7100c51a1fc1$var$CreateGroupDiv(text, groupId, allClasses, sprintFinals) {
    let div = document.createElement('div');
    div.dataset.classId = groupId;
    div.dataset.allClasses = allClasses ? '1' : '0';
    div.dataset.sprintFinals = sprintFinals ? '1' : '0';
    div.innerText = text;
    $86cd7100c51a1fc1$var$AddClass(div, 'clickable-div');
    $86cd7100c51a1fc1$var$AddClass(div, 'class-element');
    $86cd7100c51a1fc1$var$AddClass(div, 'blue-child');
    div.onclick = $86cd7100c51a1fc1$var$LeftMenuClicked;
    if (allClasses) div.dataset.i18n = 'race_all_classes';
    return div;
}
function $86cd7100c51a1fc1$var$GetDistinctClubs() {
    let addedClubs = new Set();
    let output = [];
    const runners = $86cd7100c51a1fc1$var$datatables.mainTable.data();
    for (const runner of runners){
        if (runner.club_name === null || runner.club_name.trim() == '') continue;
        if (!addedClubs.has(runner.club_name)) {
            addedClubs.add(runner.club_name);
            output.push(runner.club_name);
        }
    }
    return output;
}
function $86cd7100c51a1fc1$var$SetLeftMenuClasses() {
    $86cd7100c51a1fc1$var$leftMenu = $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES;
    $86cd7100c51a1fc1$var$PrintLeftMenu();
    $86cd7100c51a1fc1$var$SelectedGroupChanged();
}
function $86cd7100c51a1fc1$var$SetLeftMenuClubs() {
    $86cd7100c51a1fc1$var$leftMenu = $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS;
    $86cd7100c51a1fc1$var$PrintLeftMenu();
    $86cd7100c51a1fc1$var$SelectedGroupChanged();
}
function $86cd7100c51a1fc1$var$SetLeftMenuFavourites() {
    $86cd7100c51a1fc1$var$leftMenu = $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES;
    $86cd7100c51a1fc1$var$selectedGroupId = null;
    $86cd7100c51a1fc1$var$PrintLeftMenu();
}
function $86cd7100c51a1fc1$var$ExportExcel() {
    $86cd7100c51a1fc1$var$datatables.mainTable.export('Liveresultater export.xlsx');
}
function $86cd7100c51a1fc1$var$IsSprintClass(classObj) {
    return 'sprint_total_number_of_rounds' in classObj && classObj.sprint_total_number_of_rounds != null;
}
function $86cd7100c51a1fc1$var$PrintLeftMenu() {
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) {
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-classes'), 'selected');
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-favourites'), 'selected');
        $86cd7100c51a1fc1$var$AddClass(document.getElementById('left-menu-clubs'), 'selected');
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        $86cd7100c51a1fc1$var$AddClass(document.getElementById('left-menu-classes'), 'selected');
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-favourites'), 'selected');
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-clubs'), 'selected');
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) {
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-classes'), 'selected');
        $86cd7100c51a1fc1$var$RemoveClass(document.getElementById('left-menu-clubs'), 'selected');
        $86cd7100c51a1fc1$var$AddClass(document.getElementById('left-menu-favourites'), 'selected');
    }
    let classesBody = document.getElementById('classes-children');
    classesBody.innerHTML = '';
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        for (const classObj of $86cd7100c51a1fc1$var$classes){
            if ($86cd7100c51a1fc1$var$IsSprintClass(classObj)) // Print out sprint classes. That is, find the "parent" classes and print out
            // "classname prolog" and "classname finaler"
            {
                if ('parent_class_id' in classObj && classObj.parent_class_id == null) {
                    classesBody.appendChild($86cd7100c51a1fc1$var$CreateGroupDiv(classObj.name + ' ' + $86cd7100c51a1fc1$var$currentLanguage.race_sprint_prolog_suffix, classObj.class_id + "-prolog", false, false));
                    classesBody.appendChild($86cd7100c51a1fc1$var$CreateGroupDiv(classObj.name + ' ' + $86cd7100c51a1fc1$var$currentLanguage.race_sprint_finals_suffix, classObj.class_id, false, true));
                }
            } else classesBody.appendChild($86cd7100c51a1fc1$var$CreateGroupDiv(classObj.name, classObj.class_id, false, false));
        }
        classesBody.appendChild($86cd7100c51a1fc1$var$CreateGroupDiv($86cd7100c51a1fc1$var$currentLanguage.race_all_classes, '', true, false));
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) {
        let clubs = $86cd7100c51a1fc1$var$GetDistinctClubs();
        clubs.sort((a, b)=>{
            return a.localeCompare(b);
        });
        for (const club of clubs)classesBody.appendChild($86cd7100c51a1fc1$var$CreateGroupDiv(club, club, false, false));
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) {
        $86cd7100c51a1fc1$var$SelectedGroupChanged();
        return;
    }
    $86cd7100c51a1fc1$var$MarkSelectedGroup(true);
}
function $86cd7100c51a1fc1$var$LeftMenuClicked() {
    if (this.dataset.allClasses == '1') $86cd7100c51a1fc1$var$selectedGroupId = null;
    else $86cd7100c51a1fc1$var$selectedGroupId = this.dataset.classId;
    $86cd7100c51a1fc1$var$SelectedGroupChanged();
}
function $86cd7100c51a1fc1$var$MarkSelectedGroup(chooseNewIfCurrentIsInvalid) {
    const classesElements = document.getElementById('classes-children').children;
    let wasAnySelected = false;
    for(let i = 0; i < classesElements.length; ++i){
        const element = classesElements[i];
        if (element.dataset.classId == $86cd7100c51a1fc1$var$selectedGroupId || $86cd7100c51a1fc1$var$selectedGroupId === null && element.dataset.allClasses == '1') {
            $86cd7100c51a1fc1$var$AddClass(element, 'selected');
            wasAnySelected = true;
            $86cd7100c51a1fc1$var$selectedGroupIsSprint = element.dataset.sprintFinals == '1';
        } else $86cd7100c51a1fc1$var$RemoveClass(element, 'selected');
    }
    if (!wasAnySelected && chooseNewIfCurrentIsInvalid) // Ensure that we have a valid group id selected
    for(let i = 0; i < classesElements.length; ++i){
        const element = classesElements[i];
        if (element.dataset.allClasses == '1') $86cd7100c51a1fc1$var$selectedGroupId = null;
        else $86cd7100c51a1fc1$var$selectedGroupId = element.dataset.classId;
        break;
    }
}
function $86cd7100c51a1fc1$var$SelectedGroupChanged() {
    if ($86cd7100c51a1fc1$var$leftMenu != $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) // Favourites don't have a group to select.
    $86cd7100c51a1fc1$var$MarkSelectedGroup(true);
    $86cd7100c51a1fc1$var$PrintIntermediatePoints();
    let legsContainer = document.getElementById('legs-container');
    if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected() && $86cd7100c51a1fc1$var$AnyClassIsRelay() || $86cd7100c51a1fc1$var$ClassIdIsRelay($86cd7100c51a1fc1$var$selectedGroupId)) {
        if ($86cd7100c51a1fc1$var$selectedLegNumber === null) $86cd7100c51a1fc1$var$selectedLegNumber = 1;
        $86cd7100c51a1fc1$var$PrintLegs();
        $86cd7100c51a1fc1$var$RemoveClass(legsContainer, 'hidden');
    } else {
        $86cd7100c51a1fc1$var$selectedLegNumber = null;
        $86cd7100c51a1fc1$var$AddClass(legsContainer, 'hidden');
    }
    $86cd7100c51a1fc1$var$ReCreateDataTable();
    $86cd7100c51a1fc1$var$PrintTableHeading();
}
function $86cd7100c51a1fc1$var$GetMaxNumberOfLegs() {
    let maxLegs = 0;
    for (const classObj of $86cd7100c51a1fc1$var$classes)if ($86cd7100c51a1fc1$var$ClassIsRelay(classObj)) maxLegs = Math.max(maxLegs, classObj.num_legs);
    return maxLegs;
}
function $86cd7100c51a1fc1$var$SelectedLegChanged(redrawTable) {
    let legRowElements = document.getElementById('legs-children').children;
    for(let j = 0; j < legRowElements.length; ++j){
        let legsElements = legRowElements[j].children;
        for(let i = 0; i < legsElements.length; ++i){
            let element = legsElements[i];
            if (Number.parseInt(element.dataset.leg) == $86cd7100c51a1fc1$var$selectedLegNumber) $86cd7100c51a1fc1$var$AddClass(element, 'selected');
            else $86cd7100c51a1fc1$var$RemoveClass(element, 'selected');
        }
    }
    if (redrawTable) $86cd7100c51a1fc1$var$ReCreateDataTable();
    $86cd7100c51a1fc1$var$PrintTableHeading();
    $86cd7100c51a1fc1$var$PrintIntermediatePoints();
}
function $86cd7100c51a1fc1$var$GetIntermediatePoint(classId, legNumber, code) {
    const intermediatePoinstForClass = $86cd7100c51a1fc1$var$GetIntermediatePointsForClassId(classId, legNumber);
    for(let i = 0; i < intermediatePoinstForClass.length; ++i){
        // NOTE: Important to not use '===' here, as we may be comparing string and number.
        if (intermediatePoinstForClass[i].code == code) return intermediatePoinstForClass[i];
    }
    return null;
}
function $86cd7100c51a1fc1$var$PrintTableHeading() {
    let text = '';
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) text = $86cd7100c51a1fc1$var$selectedGroupId;
    else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES) {
        if ($86cd7100c51a1fc1$var$selectedGroupId === null) text = $86cd7100c51a1fc1$var$currentLanguage.race_all_classes_table_heading;
        else {
            const selectedClass = $86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId);
            if (selectedClass !== null) text = selectedClass.name;
            else text = $86cd7100c51a1fc1$var$currentLanguage.race_unknown_class_table_heading;
        }
    } else if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES) text = $86cd7100c51a1fc1$var$currentLanguage.race_favourites_table_heading;
    if ($86cd7100c51a1fc1$var$selectedLegNumber !== null) {
        if ($86cd7100c51a1fc1$var$selectedLegNumber === $86cd7100c51a1fc1$var$ALL_LEGS) text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_all_legs_table_heading;
        else text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_leg_table_heading + ' ' + $86cd7100c51a1fc1$var$selectedLegNumber;
    }
    if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.START_CODE)) text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_startlist_table_heading;
    else if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.FINISH_CODE)) text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_finish_table_heading;
    else if ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.COMBINED_CODE)) text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_combined_list_table_heading;
    else if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) text = text + ', ' + $86cd7100c51a1fc1$var$currentLanguage.race_intermediate_code_table_heading + ' ' + $86cd7100c51a1fc1$var$selectedIntermediatePoint;
    else {
        const intermediatePoint = $86cd7100c51a1fc1$var$GetIntermediatePoint($86cd7100c51a1fc1$var$selectedGroupId, $86cd7100c51a1fc1$var$selectedLegNumber, $86cd7100c51a1fc1$var$selectedIntermediatePoint);
        if (intermediatePoint !== null) text = text + ', ' + intermediatePoint.text;
    }
    const tableHeading = document.getElementById('table-heading');
    tableHeading.innerText = text;
}
function $86cd7100c51a1fc1$var$PrintRunnerStatistics() {
    let text = '';
    let numRunners = 0;
    $86cd7100c51a1fc1$var$datatables.mainTable.forEach(function() {
        ++numRunners;
    }, (0, $hKsEd.ForEachFilter).AllFiltered);
    if (numRunners === 1) text = $86cd7100c51a1fc1$var$currentLanguage.race_stats_one_runner;
    else text = numRunners + ' ' + $86cd7100c51a1fc1$var$currentLanguage.race_stats_multiple_runners;
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLASSES && ($86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.FINISH_CODE) || $86cd7100c51a1fc1$var$selectedIntermediatePoint === (0, $2NT5D.COMBINED_CODE))) {
        let count = 0;
        for (const runner of $86cd7100c51a1fc1$var$datatables.mainTable.data()){
            if ($86cd7100c51a1fc1$var$selectedGroupId !== null && runner.class_id != $86cd7100c51a1fc1$var$selectedGroupId) continue;
            if (runner.status == (0, $2NT5D.RunnerStatus).REGISTERED) ++count;
        }
        const remainingRunners = $86cd7100c51a1fc1$var$datatables.mainTable.data().filter(function(value, _index) {
            if ($86cd7100c51a1fc1$var$selectedGroupId !== null && value.class_id != $86cd7100c51a1fc1$var$selectedGroupId) return false;
            return value.status == (0, $2NT5D.RunnerStatus).REGISTERED ? true : false;
        }).length;
        text = text + ', ' + remainingRunners + ' ' + $86cd7100c51a1fc1$var$currentLanguage.race_stats_runners_remaining;
    }
    const element = document.getElementById('runner-stats');
    element.innerText = text;
}
function $86cd7100c51a1fc1$var$ShowAllLegs() {
    return $86cd7100c51a1fc1$var$selectedLegNumber == $86cd7100c51a1fc1$var$ALL_LEGS;
}
function $86cd7100c51a1fc1$var$LegClicked() {
    $86cd7100c51a1fc1$var$selectedLegNumber = Number.parseInt(this.dataset.leg);
    $86cd7100c51a1fc1$var$SelectedLegChanged(true);
}
function $86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected() {
    return $86cd7100c51a1fc1$var$selectedGroupId === null || $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS || $86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_FAVOURITES;
}
function $86cd7100c51a1fc1$var$PrintLegs() {
    let legsChildren = document.getElementById('legs-children');
    legsChildren.innerHTML = '';
    let numLegs = 0;
    if ($86cd7100c51a1fc1$var$AllClassesOrClubOrFavouritesIsSelected()) numLegs = $86cd7100c51a1fc1$var$GetMaxNumberOfLegs();
    else {
        const classObj = $86cd7100c51a1fc1$var$GetClass($86cd7100c51a1fc1$var$selectedGroupId);
        if (classObj != null) numLegs = classObj.num_legs;
    }
    // Add one leg for "Alle"
    numLegs++;
    const LEGS_PER_ROW = 4;
    let currentRow = document.createElement('div');
    $86cd7100c51a1fc1$var$AddClass(currentRow, 'legs-row');
    for(let i = 0; i < numLegs; ++i){
        let leg = document.createElement('div');
        if (i + 1 == numLegs) {
            leg.dataset.leg = $86cd7100c51a1fc1$var$ALL_LEGS.toString();
            leg.innerText = $86cd7100c51a1fc1$var$currentLanguage.race_all_legs;
        } else {
            leg.dataset.leg = (i + 1).toString();
            leg.innerText = (i + 1).toString();
        }
        $86cd7100c51a1fc1$var$AddClass(leg, 'leg');
        $86cd7100c51a1fc1$var$AddClass(leg, 'clickable-div');
        $86cd7100c51a1fc1$var$AddClass(leg, 'blue-child');
        leg.onclick = $86cd7100c51a1fc1$var$LegClicked;
        currentRow.appendChild(leg);
        if (i + 1 % LEGS_PER_ROW == 0 || i == numLegs - 1) {
            legsChildren.appendChild(currentRow);
            currentRow = document.createElement('div');
            $86cd7100c51a1fc1$var$AddClass(currentRow, 'legs-row');
        }
    }
    $86cd7100c51a1fc1$var$SelectedLegChanged(false);
}
function $86cd7100c51a1fc1$var$MarkFavourites(settings, runners) {
    for (let runner of runners)if (runner.runner_id in settings.favourites) runner.favourite = true;
    else runner.favourite = false;
}
function $86cd7100c51a1fc1$var$SortTimingChips(runners) {
    for (const runner of runners)if (runner.timing_chips != null) runner.timing_chips.sort((a, b)=>{
        return a - b;
    });
}
function $86cd7100c51a1fc1$var$HandleRunnersChanged(changes, allData) {
    if (changes == null) return;
    let settings = $86cd7100c51a1fc1$var$LoadSettings();
    let hasAnyChange = false;
    if (allData) {
        $86cd7100c51a1fc1$var$datatables.mainTable.clear();
        for (const table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.clear();
    }
    if (changes.delete.length > 0) {
        hasAnyChange = true;
        let toDelete = [];
        for (const ids of changes.delete)toDelete.push(ids[0]);
        $86cd7100c51a1fc1$var$datatables.mainTable.deleteRows(toDelete);
        for (const table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.deleteRows(toDelete);
    }
    if (changes.upsert.length > 0) {
        hasAnyChange = true;
        $86cd7100c51a1fc1$var$SortTimingChips(changes.upsert);
        $86cd7100c51a1fc1$var$MarkFavourites(settings, changes.upsert);
        (0, $jlXLs.EnsureAllIntermediatePointsArePresent)(changes.upsert, $86cd7100c51a1fc1$var$intermediatePoints);
        $86cd7100c51a1fc1$var$datatables.mainTable.upsertRows(changes.upsert);
        for (const table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.upsertRows(changes.upsert);
    }
    if (hasAnyChange) {
        $86cd7100c51a1fc1$var$RebuildResultLookup();
        $86cd7100c51a1fc1$var$CalculateRunningTimeForAll();
        $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
        for (const table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.newDraw();
        $86cd7100c51a1fc1$var$PrintRunnerStatistics();
    }
    if ($86cd7100c51a1fc1$var$leftMenu === $86cd7100c51a1fc1$var$LEFT_MENU_CLUBS) $86cd7100c51a1fc1$var$PrintLeftMenu();
}
function $86cd7100c51a1fc1$var$RaceChanged(changes) {
    let change;
    if (changes.upsert != null && changes.upsert.length > 0) change = changes.upsert[0];
    else return;
    const forceDraw = $86cd7100c51a1fc1$var$race !== null && $86cd7100c51a1fc1$var$race.accuracy != change.accuracy;
    $86cd7100c51a1fc1$var$race = change;
    let descriptionElement = document.getElementById('race_description');
    let organizerElement = document.getElementById('race_organizer');
    let dateElement = document.getElementById('race_date');
    if ('description' in $86cd7100c51a1fc1$var$race) descriptionElement.innerText = $86cd7100c51a1fc1$var$race.description;
    if ('organizer' in $86cd7100c51a1fc1$var$race) organizerElement.innerText = $86cd7100c51a1fc1$var$race.organizer;
    if (!(0, $jlXLs.IsNullOrWhitespace)($86cd7100c51a1fc1$var$race.date)) dateElement.innerText = (0, $6dhn9.FormatDate)(new Date($86cd7100c51a1fc1$var$race.date), 'dd.mm.yyyy');
    if (forceDraw) {
        $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
        for (const table of $86cd7100c51a1fc1$var$datatables.sprintTables)table.newDraw();
    }
}
function $86cd7100c51a1fc1$var$IsTimeRecentEvent(time, limit) {
    if (time === null) return false;
    if (!('passing_time' in time)) return false;
    return limit < Date.parse(time.passing_time);
}
// This and below functions are around 3-4x faster than doing
// classList.add/remove unconditionally. This is microoptimization,
// but it is used in some tight loops.
function $86cd7100c51a1fc1$var$ClassNameContainsClass(elementClassName, className) {
    const index = elementClassName.indexOf(className);
    if (index == -1) return false;
    // The below length and whitespace checks are to avoid false positives for
    // cases where i.e., elementClassName == "foobar" and className == "foo".
    if (className.length == elementClassName.length) return true;
    if (index == 0) return elementClassName[className.length] == ' ';
    return elementClassName[index - 1] == ' ';
}
function $86cd7100c51a1fc1$var$RemoveClass(htmlElement, className) {
    if ($86cd7100c51a1fc1$var$ClassNameContainsClass(htmlElement.className, className)) htmlElement.classList.remove(className);
}
function $86cd7100c51a1fc1$var$AddClass(htmlElement, className) {
    if (!$86cd7100c51a1fc1$var$ClassNameContainsClass(htmlElement.className, className)) htmlElement.classList.add(className);
}
let $86cd7100c51a1fc1$var$recentRowLimit = $86cd7100c51a1fc1$var$GetMarkRecentRowLimit();
function $86cd7100c51a1fc1$var$GetMarkRecentRowLimit() {
    return Date.now() - 60000;
}
function $86cd7100c51a1fc1$var$CalculateRunningTimeTimer() {
    $86cd7100c51a1fc1$var$recentRowLimit = $86cd7100c51a1fc1$var$GetMarkRecentRowLimit();
    $86cd7100c51a1fc1$var$CalculateRunningTimeForAll();
    $86cd7100c51a1fc1$var$datatables.mainTable.newDraw();
    setTimeout($86cd7100c51a1fc1$var$CalculateRunningTimeTimer, 1000 - new Date().getMilliseconds());
}
function $86cd7100c51a1fc1$var$CalculateRunningTimeForAll() {
    let now = Date.now();
    let relayTeamsStarttime = {};
    const runners = $86cd7100c51a1fc1$var$datatables.mainTable.data();
    for (const runner of runners)if (runner.relay_team !== null && runner.leg_number == 1) relayTeamsStarttime[runner.bib] = runner.starttime;
    for (const runner of runners){
        let intermediatePoints = [];
        if ($86cd7100c51a1fc1$var$intermediatePointsPerClass.has(runner.class_id)) intermediatePoints = $86cd7100c51a1fc1$var$intermediatePointsPerClass.get(runner.class_id);
        if (!$86cd7100c51a1fc1$var$classLookup.has(runner.class_id)) return;
        (0, $ea459ee577d5e6bd$export$fc00c3c9244e59b8)(runner, now, intermediatePoints, relayTeamsStarttime, $86cd7100c51a1fc1$var$resultLookup, $86cd7100c51a1fc1$var$classLookup.get(runner.class_id));
    }
}
function $86cd7100c51a1fc1$var$RebuildResultLookup() {
    $86cd7100c51a1fc1$var$resultLookup = (0, $ea459ee577d5e6bd$export$8ea12da737c10ae1)($86cd7100c51a1fc1$var$classes, $86cd7100c51a1fc1$var$datatables.mainTable.data());
}
let $86cd7100c51a1fc1$var$classLookup = new Map();
function $86cd7100c51a1fc1$var$RebuildClassLookup() {
    $86cd7100c51a1fc1$var$classLookup = new Map();
    for (const classObj of $86cd7100c51a1fc1$var$classes)$86cd7100c51a1fc1$var$classLookup.set(classObj.class_id, classObj);
}


//# sourceMappingURL=race.cec5e215.js.map
